import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from '@/store/toastStore'
import { buildLocationBreadcrumb } from '@/utils/locationBreadcrumb'

const DOUBLE_FIRE_GUARD_MS = 100

export function useLocationBreadcrumbCapture(): void {
    const location = useLocation()
    const locationRef = useRef(location)
    locationRef.current = location

    const lastCaptureAtRef = useRef(0)

    useEffect(() => {
        const handleCapture = (event: MouseEvent) => {
            if (!event.ctrlKey || !event.shiftKey || event.metaKey) {
                return
            }

            const target = event.target
            if (!(target instanceof Element)) {
                return
            }

            event.preventDefault()
            event.stopPropagation()

            const now = Date.now()
            if (now - lastCaptureAtRef.current < DOUBLE_FIRE_GUARD_MS) {
                return
            }
            lastCaptureAtRef.current = now

            const { pathname, search } = locationRef.current
            const breadcrumb = buildLocationBreadcrumb({ pathname, search, target })

            void navigator.clipboard.writeText(breadcrumb).then(
                () => {
                    toast.success('Copied location')
                },
                () => {
                    toast.error('Failed to copy to clipboard')
                },
            )
        }

        document.addEventListener('click', handleCapture, true)
        document.addEventListener('contextmenu', handleCapture, true)

        return () => {
            document.removeEventListener('click', handleCapture, true)
            document.removeEventListener('contextmenu', handleCapture, true)
        }
    }, [])
}
